import './EventList/EventList.scss';

(function () {
    const b = document.querySelector('#event-filter-toggle');
    if (!b) {
        return;
    }
    const textExpanded = b.dataset.textexp;
    const textCollapsed = b.dataset.textcol;
    b.style.display = '';
    const updateButton = expanded => {
        b.setAttribute('aria-expanded', expanded.toString());
        b.textContent = expanded ? textExpanded : textCollapsed;
        const icon = Object.assign(document.createElement('span'), {
            className: 'icon icon--' + (expanded ? 'chevron-up' : 'chevron-down'),
        });
        b.append(icon);
        b.classList.add('btn--icon');
    };
    updateButton(b.getAttribute('data-expanded') === 'true');
    b.addEventListener('click', function () {
        const shouldExpand = b.getAttribute('aria-expanded') === 'false';
        updateButton(shouldExpand);
        b.setAttribute('data-expanded', shouldExpand.toString());
    });
})();
